// src/pages/DebtStudio/lib/structureUtils.js
const normalizeDate = (d) =>
  typeof d === "string" ? d.slice(0, 10) : d?.toISOString()?.slice(0, 10) ?? null;

const safeNum = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
};

/**
 * Normalize any "scale-like" rows into canonical scale shape:
 *   { date, coupon, yield, price, benchmark, adjustment_bps }
 */
export function normalizeScale(rows = []) {
  if (!Array.isArray(rows) || rows.length === 0) return null;

  const cleaned = rows
    .map((r) => ({
      date: normalizeDate(r.date),
      coupon: safeNum(r.coupon ?? r.coupon_display),
      yield: safeNum(r.yield),
      price: safeNum(r.price),
      benchmark: safeNum(r.benchmark),
      adjustment_bps: safeNum(r.adjustment_bps) ?? 0,
    }))
    .filter(
      (r) =>
        r.date &&
        (r.coupon != null ||
          r.yield != null ||
          r.price != null ||
          r.benchmark != null)
    );

  return cleaned.length > 0 ? cleaned : null;
}

/**
 * Merge scale values into canonical structure rows (by date).
 */
export function mergeScaleIntoStructure(structureRows = [], scale = []) {
  const scaleMap = new Map(
    (normalizeScale(scale) || []).map((s) => [s.date, s])
  );
  return structureRows.map((r) => {
    const s = scaleMap.get(normalizeDate(r.date));
    return s
      ? {
          ...r,
          coupon: s.coupon ?? r.coupon,
          yield: s.yield ?? r.yield,
          price: s.price ?? r.price,
          benchmark: s.benchmark ?? r.benchmark,
          adjustment_bps: s.adjustment_bps ?? r.adjustment_bps,
        }
      : r;
  });
}
